import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminAttorneysAccessPage = () => {
  return (
    <>
      <Helmet>
        <title>Attorney Access - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
